// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__UiaE9","BlackTextLogo":"Logo_BlackTextLogo__yO8Aq","ForceCollapsed":"Logo_ForceCollapsed__JvrY2","WhiteTextLogo":"Logo_WhiteTextLogo__mT5jO"};